import { Post } from '@/business/post/models/post'

export function updatePosts(
  posts: Post[],
  newPost: Post,
  updateFunction: (posts: Post[], post: Post) => Post[]
): Post[] {
  let updatedPosts: Post[]

  if (newPost.replyTo != null) {
    updatedPosts = [...posts].map(post => {
      const update = {
        ...post,
      }

      if (post.id === newPost.replyTo) {
        update.replies = updateFunction(update.replies, newPost)
      }

      return update
    })
  } else {
    updatedPosts = updateFunction(posts, newPost)
  }

  return updatedPosts
}
